<template>
  <section class="w-full min-h-screen bg-h-primary-50 pb-1">
    <div class="pt-16 container mx-auto">
      <h4>
        {{
          $t("labels.generic", {
            pt: "Cursos",
            en: "Courses",
          })
        }}
      </h4>
      <div class="bg-white my-5 shadow-md">
        <ListCourses />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent } from "vue";

const ListCourses = defineAsyncComponent(
  () => import("@/views/Stats/ListCourses/list-courses.vue")
);
export default defineComponent({
  name: "stats",
  components: { ListCourses },
});
</script>
